import './css/style.scss';
import './i18n/i18n';

import { b2x } from '@b2x/react/src';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { AlertFromDto } from './AlertFromDto';
import { App } from './App';
import { BestPrice } from './BestPrice';
import { Breadcrumb } from './Breadcrumb';
import { Button, ButtonVariant } from './Button';
import { CartSku } from './CartSku';
import { Container } from './Container';
import { Countdown } from './Countdown';
import { Fetching } from './Fetching';
import { NewsletterForm } from './forms/NewsletterForm';
import { en } from './i18n/locales/en';
import { it } from './i18n/locales/it';
import { IconName, IconSize } from './Icon';
import { Loading } from './Loading';
import { LoadingOverlay } from './LoadingOverlay';
import { ModalHeader } from './Modal';
import { OffcanvasHeader } from './Offcanvas';
import { ThemeColor } from './pages/TemplatePage';
import { PayPalCheckout } from './PayPalCheckout';
import { PriceBlock } from './PriceBlock';
import { ProductTile, ProductTileBasicInfo, ProductTileExtraInfo } from './ProductTile';
import { reportWebVitals } from './reportWebVitals';
import { Test } from './Test';

b2x.init<ThemeColor, ButtonVariant, IconName, IconSize>({
  api: {
    apiKey: 'EADDCBEAABGEIAFEAJIDAD',
    productPopulate: {
      alternativeImages: true,
      attributes: true,
      bundleProducts: {
        skus: {
          price: true,
        },
      },
      priceRange: true,
      skus: {
        attributes: true,
        price: true,
      },
      variantProducts: {
        attributes: true,
      },
    },
    productTilePopulate: {
      attributes: true,
      priceRange: true,
      skus: {
        attributes: true,
        price: true,
      },
      variantProducts: true,
    },
    sessionOptions: {
      populate: {
        cart: {
          packs: {
            cartSkus: {
              giftCard: true,
              sku: {
                attributes: true,
                product: {
                  attributes: true,
                },
              },
            },
          },
          shippingProfile: true,
        },
        customer: true,
        wishlist: { products: true, skus: { product: true } },
      },
    },
  },
  cartBlockingAlerts: ['MISSING_SHIPPING_PROFILE'],
  cookiebot: {
    id: '0652ecbb-4072-411c-affa-d15a9218b441',
  },
  defaultButtonVariant: 'primary',
  enableBestPrice: true,
  enableRightOfWithdrawal: true,
  //enableProductAvailabilityEmailNotification: true,
  form: {
    buttons: {
      cancel: {
        defaultVariant: 'outline-primary',
      },
      submit: {
        defaultVariant: 'primary',
      },
    },
  },
  // googleMaps: {
  //   apiKey: 'AIzaSyAPw7khGcE8C7nrSxd_itzQilSz23LKtaU',
  // },
  hasMainCategories: true,
  i18n: {
    en: en,
    it: it,
  },
  icons: {
    arrow: {
      left: 'small-arrow-left',
    },
    close: 'delete',
    configurator: 'filter',
    download: 'small-arrow-down',
    info: 'info',
    logout: 'logout',
    minimize: 'minimize',
    passwordToggle: {
      hidden: 'hidden',
      visible: 'visible',
    },
  },
  installmentPaymentBanner: {
    paypal: {
      enabled: true,
      layout: 'text',
      text: { color: 'black', logo: 'inline' },
    },
  },
  locale: {
    default: 'en',
  },
  payPalCheckout: {
    integrationType: 'advanced',
  },
  paypal: {
    merchantClientId: 'Aeu675dG5jPOUsv24EJ9Iw1DftlLTWQKr7EFd1CczHCb8vqeZ4nl5vuyBfUsLhBbSIeJ2KU09p5ko7V4',
  },
  preselectFirstAvailableSku: true,
  productImageAspectRatio: 1600 / 2000,
  productVariantAttributesCodes: ['EQS_COLOR'],
  projectName: 'equestro',
  skusNotAvailable: 'ADD-TO-WISHLIST',
  // saveResourcesInSession: true,
  ui: 'bs5',
  variants: {
    AccountLoyaltySubpage: 'B',
    AddressFieldset: 'A',
    AlertFromDto: AlertFromDto,
    BestPrice: BestPrice,
    Breadcrumb: Breadcrumb,
    Button: Button,
    CartAddressFromAddressBookForm: 'A',
    CartAddressesForm: 'A',
    CartSku: CartSku,
    ChangePasswordForm: 'A',
    Container: Container,
    Countdown: Countdown,
    CustomerAddressForm: 'A',
    CustomerForm: 'D',
    Fetching: Fetching,
    GiftCardForm: 'A',
    InvoiceFieldset: 'A',
    Loading: Loading,
    LoadingOverlay: LoadingOverlay,
    LocaleForm: 'A',
    LoginForm: 'A',
    ModalHeader: ModalHeader,
    NewsletterForm: NewsletterForm,
    OffcanvasHeader: OffcanvasHeader,
    OrderDetails: 'A',
    OrderGuestForm: 'A',
    PayPalCheckout: PayPalCheckout,
    // PersonalDataForm: 'A',
    PriceBlock: PriceBlock,
    ProductTile: ProductTile,
    ProductTileBasicInfo: ProductTileBasicInfo,
    ProductTileExtraInfo: ProductTileExtraInfo,
    // RegistrationForm: 'A',
    SimpleSearchForm: 'A',
    Test: Test,
  },
  zakeke3DViewer: {
    //userId: 'c33bba01-3bd8-49fd-9fbe-6fecd5e401a5',
    userId: '261555',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <b2x.router.BrowserRouter>
      <b2x.ModalsContext>
        <App />
      </b2x.ModalsContext>
    </b2x.router.BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
